// Replace Window Loaded - All assets are ready
/*
  windowLoad(function() {
    console.log('Window is loaded');
  });
*/
function windowLoad(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener("load", callback);
  }
}